import { Component, OnInit, OnDestroy } from '@angular/core';
import { Tabs } from "../../shared/tabs/tabs";
import { TabItem } from '../../shared/models/tabs-models';
import { RouterOutlet, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LeadService } from '../shared/service/leads.service';

@Component({
  selector: 'app-add-new-lead',
  standalone: true,
  imports: [Tabs, RouterOutlet],
  templateUrl: './add-new-lead.html',
  styleUrl: './add-new-lead.css',
})
export class AddNewLead implements OnInit, OnDestroy {

  leadSeq: number | null = null;
  isViewMode = false;   // ✅ track view mode
  leadsTabs: TabItem[] = [];

  private subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private leadService: LeadService,
  ) {}

  ngOnInit(): void {
    // 1️⃣ Watch router events — har navigation pe sync karo
    this.subs.push(
      this.router.events
        .pipe(filter((e) => e instanceof NavigationEnd))
        .subscribe(() => this.syncFromChild()),
    );

    // 2️⃣ Initial sync
    this.syncFromChild();

    // 3️⃣ Service updates (after save)
    this.subs.push(
      this.leadService.leadSeq$.subscribe((seq) => {
        this.leadSeq = seq;
        this.buildTabs();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  /* ================= SYNC FROM ACTIVE CHILD ROUTE ================= */
  private syncFromChild(): void {
    // Active child route find karo
    let r = this.route.firstChild;
    while (r?.firstChild) r = r.firstChild;

    // Lead ID
    const idParam = r?.snapshot.paramMap.get('id');
    if (idParam) {
      this.leadSeq = +idParam;
      this.leadService.setLeadSeq(this.leadSeq);
    }

    // ✅ View mode — har navigation pe read karo
    this.isViewMode = r?.snapshot.queryParamMap.get('mode') === 'view';

    this.buildTabs();
  }

  /* ================= BUILD TABS ================= */
  buildTabs(): void {
    const queryParams = this.isViewMode ? { mode: 'view' } : {};

    this.leadsTabs = [
      {
        label: 'DEMOGRAPHIC.TITLE',
        route: this.leadSeq
          ? `/add-new-leads/demographic/${this.leadSeq}`
          : `/add-new-leads/demographic`,
        queryParams,
      },
      {
        label: 'LEADS.DOCUMENTS',
        route: this.leadSeq
          ? `/add-new-leads/document/${this.leadSeq}`
          : `/add-new-leads/document`,
        queryParams,
        disabled: !this.leadSeq,
      },
      {
        label: 'TERM_SHEET.TITLE',
        route: this.leadSeq
          ? `/add-new-leads/add-terms/${this.leadSeq}`
          : `/add-new-leads/add-terms`,
        queryParams,
        disabled: !this.leadSeq,
      },
    ];
  }
}